import { PupilLinkMismatch } from "@core/models/domain/pupil-link.domain";

export interface PupilLinkState {
  mismatches: PupilLinkMismatch[];
  loading: boolean;
  error: string | null;
  // Id of the request currently being linked or dismissed, so the page can disable its buttons.
  actionInProgressId: string | null;
}

export const initialPupilLinkState: PupilLinkState = {
  mismatches: [],
  loading: false,
  error: null,
  actionInProgressId: null,
};
